import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Uxum Grotesque';
    src: url('/fonts/UxumGrotesque-Regular.woff') format('woff');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Uxum Grotesque';
    src: url('/fonts/UxumGrotesque-Regular.woff') format('woff');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Uxum Grotesque';
    src: url('/fonts/UxumGrotesque-Regular.woff') format('woff');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Uxum Grotesque';
    src: url('/fonts/UxumGrotesque-Regular.woff') format('woff');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Uxum Grotesque';
    src: url('/fonts/UxumGrotesque-Regular.woff') format('woff');
    font-weight: 800;
    font-style: normal;
    font-display: swap;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html,
  body {
    cursor: url('/cursor-default.svg') 6 4, auto;
  }

  a,
  button,
  [role='button'],
  label[for],
  summary,
  input[type='submit'],
  input[type='button'],
  input[type='checkbox'],
  input[type='radio'],
  select,
  .cursor-pointer {
    cursor: url('/cursor-pointer.svg') 6 4, pointer;
  }

  input[type='text'],
  input[type='email'],
  input[type='password'],
  input[type='search'],
  input[type='number'],
  input[type='tel'],
  input[type='url'],
  textarea {
    cursor: text;
  }

  /* Lazy media resizing must not hijack programmatic scrolls (react-scroll). */
  html,
  body {
    overflow-anchor: none;
  }

  body {
    font-family: ${({ theme }) => theme.fonts.body};
    background: ${({ theme }) => theme.colors.backgroundGradient || theme.colors.background};
    background-attachment: fixed;
    color: ${({ theme }) => theme.colors.ink};
    line-height: 1.6;
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  button {
    font-family: inherit;
    cursor: pointer;
    border: none;
    outline: none;
    background: transparent;
    color: inherit;
  }

  input, textarea {
    font-family: inherit;
    outline: none;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  ul, ol {
    list-style: none;
  }

  ::selection {
    background: ${({ theme }) => theme.colors.accent};
    color: #FFFFFF;
  }

  :focus {
    outline: none;
  }

  :focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.accent};
    outline-offset: 2px;
  }

  @media (max-width: 768px) {
    html {
      font-size: 14px;
    }
  }

  @media (max-width: 480px) {
    html {
      font-size: 13px;
    }
  }
`;

export default GlobalStyles;
